import React from 'react';
import PropTypes from 'prop-types';

export default function Link({ deal, name }) {
  const value = deal[name];

  if (value?.path) {
    return <a href={value.path}>{value.label}</a>;
  } else {
    return value?.label || null;
  }
}

Link.propTypes = {
  deal: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
};
